/*
 * Title: 회원초대 서비스
 * Author: KimTaeOh (taeoh.kim@gentlepie.com )
 * Date: 2021-04-03
 * @Object: GentleServiceInviteMember
 * @Property Value
 * - sponserId: 후원인 아이디 
 * - sponserName: 후원인 이름 
 * @Property Method
 * - selectInviteType: 회원초대방식선택
 * - sponserIsMe: 나를 후원인으로 초대장 생성
 * - sponserIsOther: 다른 사람을 후원인으로 초대장 생성 
 */

/* 2025.2 - 센터조회
"example": {
  "request": "GET https://oadev.atomyn.com/chatbotInterestCustomer",  // 샘플 요청 URL
  "response": {
    "result": "200",  // 응답 코드 (성공)
    "resultMessage": "SUCCESS",  // 응답 메시지
    "siteNo": "KR",  // 요청한 사이트 번호
    "locale": "ko_KR",  // 요청한 사이트 언어 및 번호
    "time": "2025-02-17T13:00:30.198328800+09:00[Asia/Seoul]",  // 응답 시간
    "totalCount": 1,  // 전체 회원 수
    "pageSize": 10,  // 한 페이지당 회원 수
    "currentPage": 1,  // 현재 페이지 번호
    "items": [
      {
        "JisaCode": "01",  // 지사 코드
        "CustNo": "S3596377",  // 회원 번호
        "CustName": "test",  // 회원 이름
        "CurrentMastership": "02",  // 현재 직급
        "Level": "1",  // 회원 차수
        "CustGubun": "0",  // 회원 구분
        "RegDate": "20141114000000",  // 등록일
        "CustDate": "20150110000000",  // 최초 구매일
        "StopYn": "0",  // 탈퇴 예정 여부
        "ChuchonNo": "S3596364",  // 추천인 번호
        "IsInterested": "1",  // 관심 회원 여부
        "PvStatus": {
          "Current": "0",  // 현재 PV
          "Total": "0"  // 전체 PV
        },
        "CenterInfo": {
          "CenterName": "서울종로"  // 센터 이름
        },
        "SpouseInfo": {
          "CustName": "test"  // 배우자 이름
        },
        "SponsorInfo": {
          "CustNo": "S3596364"  // 후원인 번호
        }
      }
    ]
  }
}
*/

import GentleWidget from '../common/widget';
import GentleUtil from '../common/util';
import GentleLang from '../common/lang';
import GentleComponentButton from '../component/button';
import GentleComponentBubble from '../component/bubble';
import GentleComponentQuickReply from '../component/quickReply';
import GentleProxy from '../common/proxy';
import GentleAppState from '../common/appstate';
import language from '../lang';
import search from '../lang/search';

var GentleServiceJoin = Object.create( GentleWidget,{
    sponserId:{ writable: true, configurable: false, enumerable: true},
    sponserName: { writable: true, configurable: false, enumerable: true}
})

// 카드 템플릿
GentleServiceJoin.card = function(opts){
    /**
    info:
    buttons: [
        {
            title:
            handler
        },
        ...        
    ] 
     */
    const element = opts.info;
        
    const html = `
    <div style="border:solid 1px red">
        <image width="100px" src="${element.image}"></image>
        <div>${element.date}</div>
        <div>${element.badge}</div>
        <div>${element.name}</div>
        <div>${element.price}</div>
        <div>${element.pv}</div>
        <div name="buttons" />
    </div>`;

    const $card = $(html);

    opts.buttons.forEach(button => {
        const html = `
        <button style="border:solid 1px green">${button.title}</button>
        `;
        const $button = $(html);
        $button.bind('click', button.handler);
        
        // todo: <div name="buttons" /> 에 삽입하기
        $card.find('[name="buttons"]').append($button);
    });
    return $card;
}

GentleServiceJoin.main = function(json){

    const component =  Object.create(this);

    const render = function(data){
        // 봇버블
        {
            const html = GentleLang.translateService(language.join, language.join.type.Bot1);
            

            var bubble = Object.create( GentleComponentBubble );   
            bubble.createComponent({
                    "html": [html],
            });
            bubble.insert();
        }
        {
            // const html = GentleLang.translateService(language.join, language.join.type.Bot2);
            // var bubble = Object.create( GentleComponentBubble );   
            // bubble.createComponent({
            //         "html": html,
            // });
            // bubble.insert();
        }

        // button
        {
            const text = GentleLang.translateService(language.join, language.join.type.FindCenter);
            const option = [
                {
                    text: text,
                    user: 'user',
                    onClick: function () {
                        console.log('센터 정보 찾기');
                        // GentleServiceJoin.location(json);
                    },
                },
            ]
            var button = Object.create( GentleComponentButton);
            button.createComponent(option);
            button.insert();
        }
        GentleUtil.timeStamp();
    };

    render();
}

GentleServiceJoin.location = function(json){
    const component =  Object.create(this);

    const render = function(){
        const array = [
            {  
                code: '01',
                KR: '경기',
                EN: 'Metropolitan area',
            },
            {
                code: '02',
                KR: '서울',
                EN: 'Yeongnam area',
            },
            {
                code: '03',
                KR: '부산',
                EN: 'Honam area',
            },
            {
                code: '04',
                KR: '대구',
                EN: 'Chungcheong area',
            },
            {
                code: '05',
                KR: '인천',
                EN: 'Gangwon area',
            },
            {
                code: '06',
                KR: '광주',
                EN: 'Jeju area',
            },
            {
                code: '07',
                KR: '대전',
                EN: 'Jeju area',
            },
            {
                code: '08',
                KR: '울산',
                EN: 'Jeju area',
            },
            {
                code: '09',
                KR: '세종',
                EN: 'Jeju area',
            },
            {
                code: '10',
                KR: '기타',        
                EN: 'etc area',        
            }
        ]
    
        // 봇버블
        {
            const html = GentleLang.translateService(language.join, language.join.type.SelectLocation);
            var bubble = Object.create( GentleComponentBubble );   
            bubble.createComponent({
                    html,
            });
            bubble.insert();
        }

        // 카드 재활용
        {
            const title = GentleLang.translateService(language.join, language.join.type.Location) ; // 하위회원 선택

            let html = `
            <div class="card-view">
                <div class="margin-container">
                    <h3>${title}</h3>
                    <div class="gentle-quickreply-group btn-white" name="list">
                    </div>
                </div>
            </div>
            `

            // component 초기화. 이 코드 후에 레퍼런스로 접근
            {
                let $container = $(html)
                component.setPrefix("join");
                component.init($container);
                component.insert();
            }

            for (let index = 0; index < array.length; index++) {
                const element = array[index];
                const lang = GentleAppState.lang.toUpperCase();
                console.log('lang>', lang);

                const html = `<button>${element[lang]}</button>`

                const $card = $(html);        
                $card.bind('click', function(){
                    console.log('지역 선택', element);
                    GentleServiceJoin.popupList(element);
                });
        
                component.find('[name="list"]').append($card);
            }
        }
        GentleUtil.timeStamp();
    };
    render();
}

GentleServiceJoin.popupList = function(param){
    console.log('GentleServiceJoin.popupList>', param);
    const component =  Object.create(this);

    let curPage = 1;
    let cards = [];   // element array
    let $list;  // 목록
    let $input_search;  // 검색 입력필드
    let $total;
    let totalCount = 0; // 총 카운트

    let $notice;    // 메시지 영역
    let $warning;    // 메시지 영역
    let $buttonMore;    // 더보기 버튼

    let SearchKeyword = GentleAppState.lang.toUpperCase() === 'KR' ? param.KR: param.EN;

    // api
    const request = function()
    {
        $notice.removeClass('show');
        $buttonMore.removeClass('hide')
        const onSuccess = function(data){
            console.log('GentleServiceJoin onSuccess>', data);
            switch(data.result){
                case "200":

                    // 2022-api-센터목록
                    const {items} = data;
                    // const {items:List} = Data;
                    
                    if(items && items.length > 0){
                        curPage = curPage+10;
                        addCard(data);

                        // 기존 요소 업데이트 > 총 카운트 업데이트
                        {
                            totalCount = data.totalCount;
                            $total.html(GentleLang.translate(GentleLang.type.Count, {count: items.length, total: totalCount}));
                            // GentleUtil.scrollDownSlidePopup();
                        }

                        if(items.length >= totalCount)
                        {
                            $buttonMore.removeClass('default');
                            $buttonMore.addClass('disabled');
                        }
                    }
                    else{
                        $total.html(GentleLang.translate(GentleLang.type.Count, {count: items.length, total: 0}));
                        $notice.addClass('show');
                        $buttonMore.addClass('hide')
                    }
                    break;
                default:
                    console.log('실패');
                    $warning.css('display', 'block');                                    
                    $warning.html(GentleLang.translateService(language.account, language.account.type.CheckIt));
                }

        };
        const onFailed = function(data){
            console.log('onFailed');
        }

        const proxy = Object.create(GentleProxy);
        const body = {SearchKeyword, curPage};

        // proxy.request("global-center", body, onSuccess, onFailed );
        // 2025.2 센터목록 조회
        proxy.request("2025-center", body, onSuccess, onFailed );
    }

    const resetCards = function(){
        cards.forEach(element => {
            element.css('background-color', 'white');
        });
    };

    const doSearch = function(text){
        console.log('search : ', text);

        $input_search.val('');
        {
            $list.empty();
            cards.splice(0,cards.length);
            $buttonMore.removeClass('disabled');
            $buttonMore.addClass('default');
        }

        // todo : request : 
        curPage = 10;
        SearchKeyword = text;
        request();
    };

    // 2025.2 센터목록 조회 - 기존과 동일
    const addCard = function(Data){
        console.log('addCard>', Data);

        const { items } = Data;
        // 2022-api : 센터목록
        // const { items:List } = Data;

        const titleTel = GentleLang.translateService(language.join, language.join.type.Tel);
        const titleAddress = GentleLang.translateService(language.join, language.join.type.Address);
        
        $list.empty();
        items.forEach(element => {
            /*
            PostNo	int		법인코드
            Addr1	string		센터코드
            Addr2	string		센터명
            */

            // 2025.2 센터목록 조회 - 기존과 동일
            const name = element.label;
            const phone = element.cellphone;
            const addr1 = element.address.address;
            const addr2 = element.address.detailAddress;

            /* 2022-api-센터목록            
            {
            const name = element.centerName;
            const phone = element.phone;

            const {address} = element;

            const addr1 = address.address // or address_kr
            const addr2 = address.detailAddress
            }
            */
    
            let html = `
            <li>                    
                <h3>${name}</h3>
                <p class="tel">${titleTel} : <a href="tel:${phone}">${phone}</a></p>
                <p class="address">${titleAddress} : ${addr1} ${addr2}</p>
            </li>
            `;
    
            const $card = $(html);
            cards.push($card);
    
            $card.find('div').bind('click', function(){
                resetCards();
                console.log(element);
                $card.css('background-color', 'red');
            });
            $list.append($card);
        });
    }

    const render = function(){
        const title = GentleLang.translateService(language.join, language.join.type.CenterInfoView); // 하위회원 선택
        const placeholder = GentleLang.translateService(language.join, language.join.type.CenterPlaceholder);
        const section = GentleLang.translateService(language.join, language.join.type.CenterInfo);
        const button_title = GentleLang.translate(GentleLang.type.ButtonMore);
        const notfound = GentleLang.translateService(language.join, language.join.type.NotFound);

        let html = `
        <div id="center-location-container">
            <div class="search-field-container">
                <div class="search-field">
                    <input type="text" placeholder="${placeholder}">
                    <i class="at-icon at-search at-3x"></i>
                </div>
            </div>

            <div class="info-box flex-box space-between">
                    <span>센터정보</span>
                    <span name="total">
                    </span>
            </div>

            <p class="notice">${notfound}</p>

            <ul name="list">
            </ul>
            <div class="gentle-button-group" name="button-more">
                <div class="wide-button">
                    <button type="button" class="primary  default" name="more">${button_title}</button>
                </div>
            </div>
        </div>
        `

        let $container = $(html)

        // bind
        $notice = $container.find('.notice');
        $warning = $container.find('.info');
        console.log('notice> ', $notice);

        $container.find('.at-search').bind('click',function() {
            const text = $input_search.val();
            doSearch(text);
        });

        // $buttonMore = $container.find('[name="button-more"]');

        // bind
        {
            $list = $container.find('[name="list"]');
            $total = $container.find('[name="total"]');
            $buttonMore = $container.find('[name="more"]');
        }

        // 엔터
        {
            $input_search = $container.find('input');
            $input_search.keydown(function(key) {
                if (key.keyCode == 13) {
                    const text = $input_search.val();
                    doSearch(text);
                    $input_search.val('');
                    $input_search.attr("readonly",true);
                    $input_search.focus();
                    setTimeout(function(){ $input_search.attr("readonly",false);}, 50);
                }
            });
        }

        // button
        $container.find('button').bind('click',function() {
            console.log('더보기')
            request();
        });

        GentleUtil.createSlidePopup({title, content: $container, autoHeight: 'fix'});
    };
    
    render();

    SearchKeyword = GentleAppState.lang.toUpperCase() === 'KR' ? param.KR : param.EN;
    request();
}

export default GentleServiceJoin;